import { render } from "./SpinnerStyle.vue?vue&type=template&id=20d97ae5&scoped=true"
import script from "./SpinnerStyle.vue?vue&type=script&lang=js"
export * from "./SpinnerStyle.vue?vue&type=script&lang=js"

import "./SpinnerStyle.vue?vue&type=style&index=0&id=20d97ae5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d97ae5"]])

export default __exports__